var debounce = function (func, wait, immediate) {
  if (wait === void 0) {
    wait = 500;
  }
  if (immediate === void 0) {
    immediate = true;
  }
  var timer;
  var context;
  var args;
  var later = function () {
    return setTimeout(function () {
      timer = null;
      func.apply(context, args);
      context = args = null;
    }, wait);
  };
  return function () {
    var params = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      params[_i] = arguments[_i];
    }
    if (params && params[0] && params[0].persist) {
      params[0].persist();
    }
    // @ts-ignore
    context = this;
    args = params;
    if (!timer) {
      timer = later();
      if (immediate) {
        func.apply(context, params);
      }
    } else {
      clearTimeout(timer);
      timer = later();
    }
  };
};
export default debounce;